/*
 * Copyright (c) 2018 Bruce Schubert.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {NavItem, NavLink} from 'reactstrap';


export default class NavBarItem extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    card: PropTypes.object,
    closingCards: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    if (this.props.card) {
      this.props.card.close();
    }
  }

  toggle () {
    const {closingCards, card} = this.props;
    if (closingCards) {
      closingCards.forEach(closingCard => {
        if (closingCard && closingCard !== card) {
          closingCard.close()
        }
      })
    }

    if (card) {
      card.toggle();
    }
  }

  /**
   * Renders a 'reactstrap' NavItem for a Navbar.
   */
  render() {
    return (
        <NavItem>
          <NavLink role='button' onClick={this.toggle}>
            <FontAwesomeIcon icon={this.props.icon} />
            <span className="d-none d-sm-inline pl-1" aria-hidden="true">{this.props.title}</span>
          </NavLink>
        </NavItem>
    )
  }
}
